import React from 'react';
import { Box, Card, CardContent, CardMedia, Typography, Grid, Button } from '@mui/material';
import { motion } from 'framer-motion';
import mweb from '../Assets/mycubeweb.png';
import mapp from '../Assets/mycubeApp.png';
import nlfw from '../Assets/nlfweb.png';
import bobby from '../Assets/bobby.png';
import cdat from '../Assets/cdat.jpg';

// Dummy Data (You can replace this with actual data)
const projects = [
  {
    id: 1,
    name: 'MyCubeEvents_Web',
    role: 'Full Stack Developer',
    techStack: ['React', 'Node.js', 'Firebase'],
    description: 'A project that involves building a web app for Events Ticket Booking.',
    image: mweb,
    liveLink: 'https://your-live-project-link.com',
  },
  {
    id: 2,
    name: 'MyCubeEvents_App',
    role: 'Full Stack Developer',
    techStack: ['Flutter', 'Firebase'],
    description: 'A mobile application built for Events Ticket Booking.',
    image: mapp,
    liveLink: 'https://your-live-project-link.com',
  },
  {
    id: 3,
    name: 'Natural Life Foundation',
    role: 'Full Stack Developer',
    techStack: ['HTML', 'CSS', 'JS', 'MongoDB_Atlas', 'ExpressJS', 'NodeJS'],
    description: 'A website built for a foundation with PayPal donation functionality.',
    image: nlfw,
    liveLink: 'https://your-live-project-link.com',
  },
  {
    id: 4,
    name: 'Bobby Butcher',
    role: 'Full Stack Developer',
    techStack: ['Flutter', 'Firebase'],
    description: 'A mobile application built for a meat purchasing app.',
    image: bobby,
    liveLink: 'https://your-live-project-link.com',
  },
  {
    id: 5,
    name: 'CD Automation',
    role: 'Full Stack Developer',
    techStack: ['Flutter', 'Firebase'],
    description: 'A mobile application built for meter reading note-taking.',
    image: cdat,
    liveLink: 'https://your-live-project-link.com',
  },
];

const Projects = () => {
  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    hover: { scale: 1.05, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
        backgroundColor: 'background.paper',
        minHeight: '100vh',
      }}
    >
      <Typography variant="h4" sx={{ marginBottom: 4, textAlign: 'center' }}>
        My Internship Projects
      </Typography>

      {/* Projects Grid with Animation */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Grid container spacing={4} justifyContent="center">
          {projects.map((project) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={project.id}
              display="flex"
              justifyContent="center"
            >
              <motion.div
                variants={cardVariants}
                whileHover="hover"
                whileTap={{ scale: 0.98 }}
              >
                <Card sx={{ maxWidth: 345, cursor: 'pointer' }}>
                  {/* Project Image */}
                  <CardMedia
                    component="img"
                    height="200"
                    image={project.image}
                    alt={project.name}
                  />
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {project.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Role:</strong> {project.role}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Tech Stack:</strong> {project.techStack.join(', ')}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ marginTop: 1 }}
                    >
                      <strong>Description:</strong> {project.description}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ marginTop: 1 }}
                    >
                      <strong>Note:</strong> Cannot share the source code due to internship confidentiality.
                    </Typography>
                  </CardContent>

                  {/* Button to View Project */}
                  {/* <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      href={project.liveLink}
                      target="_blank"
                      sx={{ textDecoration: 'none' }}
                    >
                      View Live Project
                    </Button>
                  </Box> */}
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Box>
  );
};

export default Projects;
